<script setup>
import { Line } from 'vue-chartjs'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Filler
} from 'chart.js'

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Filler
)

defineProps({
  data: {
    type: Object,
    required: true
  }
})

const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins:  {
    legend: {
      display: true
    },
    tooltip: {
      enabled: true
    }
  },
  scales: {
    y: {
      display: false,
      beginAtZero: true
    },
    x: {
      display: false
    }
  }
}
</script>

<template>
  <Line v-if="data" :data="data" :options="options" />
</template>
